import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ManorBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MANOR;
}

export default ManorBuildingTileEntity;
